import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { GreyBtnDisabled } from 'Stories/Button/Button.stories'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import { CustomInputWithLabel } from 'Shared/components/CustomInputWithLabel/CustomInputWithLabel'
import { AddSpotifyTrackSearchInputProps } from './AddSpotifyTrackSearchInputProps'

import {
  CustomInputWrapper,
  ErrorBlock,
  SearchContainer,
  SearchFormBtnBlock,
} from './styles'

const AddSpotifyTrackSearchInput: FunctionComponent<AddSpotifyTrackSearchInputProps> = ({
  searchText,
  setSearchText,
  errorText,
  setErrorText,
  isSearch,
  setIsShowModal,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Desktop>
        <SearchContainer>
          {errorText ? (
            <ErrorBlock>
              <span>{t(errorText)}</span>
              <DottedBtn
                content="Try to search again"
                onClick={() => setErrorText('')}
              />
            </ErrorBlock>
          ) : (
            <>
              <CustomInputWrapper>
                <CustomInputWithLabel
                  labelText="Track name or URL"
                  inputValue={searchText}
                  inputAttributes={{
                    placeholder: 'Type your track name or URL from Spotify',
                    onChange: e => setSearchText(e.target.value),
                    value: searchText,
                  }}
                />
              </CustomInputWrapper>
              {/* <SearchFormBtnBlock>
                <GreyBtnDisabled disabled color="greyDisabled">
                  {isSearch
                    ? t('createCampaignPage.searching')
                    : t('createCampaignPage.searchTrack')}
                </GreyBtnDisabled>
              </SearchFormBtnBlock> */}
            </>
          )}
        </SearchContainer>
      </Desktop>

      <Mobile>
        <SearchContainer>
          {errorText ? (
            <ErrorBlock>
              <span>{t(errorText)}</span>
              <DottedBtn
                content="Try to search again"
                onClick={() => {
                  setErrorText('')
                  setSearchText('')
                  setIsShowModal?.()
                }}
              />
            </ErrorBlock>
          ) : (
            <CustomInputWrapper>
              <CustomInputWithLabel
                labelText=""
                inputValue=""
                inputAttributes={{
                  placeholder: 'Track name or URL from Spotify',
                  onClick: () => setIsShowModal?.(),
                  style: { caretColor: 'transparent' },
                  value: '',
                }}
              />
            </CustomInputWrapper>
          )}
          {/* {!errorText && (
            <SearchFormBtnBlock>
              <GreyBtnDisabled disabled color="greyDisabled">
                {isSearch
                  ? t('createCampaignPage.searching')
                  : t('createCampaignPage.searchTrack')}
              </GreyBtnDisabled>
            </SearchFormBtnBlock>
          )} */}
        </SearchContainer>
      </Mobile>
    </>
  )
}
export default AddSpotifyTrackSearchInput
